/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Connection_Details_DescriptionInputs */



/**
* | output |
* | --- |
* | "Test the connection, then choose the models to make available." |
*
* @param {Private_Models_Connection_Details_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_connection_details_description = /** @type {((inputs?: Private_Models_Connection_Details_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Connection_Details_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Testen Sie die Verbindung und wählen Sie dann die Modelle aus, die verfügbar sein sollen.")
	return /** @type {LocalizedString} */ ("Test the connection, then choose the models to make available.")
});